<medpace-page [isFullHeight]="true" [isFullWidth]="true" [additionalClasses]="'gap-medpace'">
    <h1>Sites</h1>
    <medpace-sites class="flex h-full" />
</medpace-page>
